
import { getStructuralPlate } from '@/modules/storm'
import { latex_units, roundToTwoDigits } from '@/services/unit.service'
import { modelViewerStore } from '@/store/modelViewer.store'
import { StructuralPlate } from '@consteel/storm'
import Vue from 'vue'
import InfoTable from './InfoTable.vue'
import { TableNode } from './TableNode'

export default Vue.extend({
  name: 'StructuralPlateTable',
  components: {
    InfoTable,
  },
  props: {
    compare: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    primaryMember(): StructuralPlate | null {
      if (!modelViewerStore.model.rawSmadsteelModel) return null

      return getStructuralPlate(
        modelViewerStore.model.rawSmadsteelModel,
        modelViewerStore.selectedIds[0]
      )
    },
    secondaryMember(): StructuralPlate | null {
      if (!this.compare || !modelViewerStore.secondaryModel.rawSmadsteelModel) return null

      return getStructuralPlate(
        modelViewerStore.secondaryModel.rawSmadsteelModel,
        modelViewerStore.selectedIds[0],
        true
      )
    },
    primaryItems(): TableNode[] {
      return this.getTableItemsFromModelItem(this.primaryMember)
    },
    secondaryItems(): TableNode[] {
      return this.getTableItemsFromModelItem(this.secondaryMember)
    },
  },
  methods: {
    getTableItemsFromModelItem(item: StructuralPlate | null): TableNode[] {
      if (!item) return []

      return [
        {
          name: this.$t('Name'),
          value: item.name,
        },
        {
          name: this.$t('Material'),
          value: item.material?.name,
        },
        {
          name: this.$t('Thickness'),
          value: roundToTwoDigits(item.thickness),
          unit: latex_units.mm,
        },
      ]
    },
  },
})
